'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dMediator$0024$0024anon$002418 from "./presto.-Mediator$$anon$18.js";
var $p;
/** @constructor */
function $c_Lpresto_Mediator$() {
}
export { $c_Lpresto_Mediator$ as $c_Lpresto_Mediator$ };
$p = $c_Lpresto_Mediator$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Mediator$;
/** @constructor */
function $h_Lpresto_Mediator$() {
}
export { $h_Lpresto_Mediator$ as $h_Lpresto_Mediator$ };
$h_Lpresto_Mediator$.prototype = $p;
$p.aeh = (function(request, execute) {
  var bus = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_eventbus_EventBus();
  var results = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_eventbus_EventBus();
  var busy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a5(false);
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_EventStream$();
  var stream = bus.br;
  var this$6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_CombinableStream$().vp(stream, request);
  var project$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x$1) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure)) {
      var error = x$1.ak;
      return ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_EventStream$()).bu(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(error), false);
    }
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var valid = x$1.T;
      $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_state_Var__set__O__V(busy, true);
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(execute.v(valid), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((result) => {
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_state_Var__set__O__V(busy, false);
        return result;
      })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    }
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$1);
  }));
  return new $j_presto$002e$002dMediator$0024$0024anon$002418.$c_Lpresto_Mediator$$anon$18(request, bus, results, busy, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_Observable$().ba.aZ(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this$6, project$1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$())), this);
});
var $d_Lpresto_Mediator$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Mediator$, "presto.Mediator$", ({
  Mq: 1
}));
export { $d_Lpresto_Mediator$ as $d_Lpresto_Mediator$ };
var $n_Lpresto_Mediator$;
function $m_Lpresto_Mediator$() {
  if ((!$n_Lpresto_Mediator$)) {
    $n_Lpresto_Mediator$ = new $c_Lpresto_Mediator$();
  }
  return $n_Lpresto_Mediator$;
}
export { $m_Lpresto_Mediator$ as $m_Lpresto_Mediator$ };
//# sourceMappingURL=presto.-Mediator$.js.map
